import AuthRoute from "shared/routes/authRoute";
import Toast from "shared/components/common/toast";
import { PhaseAnimationProvider } from "shared/context/PhaseAnimationContext";
import "shared/utils/theme.scss";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <PhaseAnimationProvider>
        <AuthRoute />
        <Toast />
      </PhaseAnimationProvider>
    </div>
  );
}
export default App;
